import {PropsWithChildren} from 'react';
import {UnnormalizedProps} from '@yosmanyga/core-style';
import {Container} from '@yosmanyga/rich-ui';
import topLeft from './assets/images/top-left.png'
import topCenter from './assets/images/top-center.png'
import topRight from './assets/images/top-right.png'
import centerLeft from './assets/images/center-left.png'
import centerRight from './assets/images/center-right.png'
import bottomLeft from './assets/images/bottom-left.png'
import bottomCenter from './assets/images/bottom-center.png'
import bottomRight from './assets/images/bottom-right.png'

const ManuscriptLayout = ({
    footer,
    children,
    ...props
}: PropsWithChildren<{
    footer?: boolean;
} & UnnormalizedProps>) => {
    return <Container width="100%" {...props}>
        <Container flow="row" width="100%">
            <Container
                width={18}
                height={29}
                background={`${topLeft} no-repeat`}
            />
            <Container
                flex={{
                    grow: 1,
                }}
                height={29}
                background={`${topCenter} repeat-x`}
            />
            <Container
                width={18}
                height={29}
                background={`${topRight} no-repeat`}
            />
        </Container>

        <Container flow="row" width="100%">
            <Container
                width={18}
                background={`${centerLeft} repeat-y left top`}
            />
            <Container
                flex={{
                    grow: 1,
                    basis: 'fit-content'
                }}
                background={'#AAAAAA'}
                padding={1}
                wrap='anywhere'
                {...props}
            >
                {children}
            </Container>
            <Container
                width={18}
                background={`${centerRight} repeat-y right top`}
            />
        </Container>

        {footer && <Container flow="row" width="100%">
            <Container
                width={18}
                height={29}
                background={`${bottomLeft} no-repeat`}
            />
            <Container
                flex={{
                    grow: 1,
                }}
                height={29}
                background={`${bottomCenter} repeat-x`}
            />
            <Container
                width={18}
                height={29}
                background={`${bottomRight} no-repeat`}
            />
        </Container>}
    </Container>
};

export {ManuscriptLayout};
